import React from 'react';
import { LdgGraphExplorer } from '../content/ldgGraph';
export function LdgGraphPage() {
  return <div className="h-full flex flex-col bg-white" data-id="element-7044" data-mp="2z75pp48i9xzq">
      {/* Header */}
      <div className="px-6 py-4 border-b border-gray-200 bg-white flex-shrink-0" data-id="element-7045" data-mp="346s7zs36y4fe">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-7046" data-mp="344p9ejnz32z2">
          Leerpad Graaf (LDG)
        </h1>
        <p className="text-sm text-gray-500 mt-1" data-id="element-7047" data-mp="38zbjmjibiphk">
          Interactieve visualisatie van alle vraagfamilies en hun onderlinge
          afhankelijkheden.
        </p>
      </div>

      {/* Graph Explorer - takes full remaining height */}
      <div className="flex-1 relative overflow-hidden" data-id="element-7048" data-mp="3mx04vsgaryn5">
        <LdgGraphExplorer data-id="element-7049" data-mp="3mv6zeghf7kgq" />
      </div>
    </div>;
}